import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { Text } from '@resiliatech/birdsong'
import DesktopOnlyViewSvg from './DesktopOnlyViewSvg'
import useStyles from './styles'

type Props = {
  pageTitle: string
}

const DesktopOnlyView = ({ pageTitle }: Props) => {
  const classes = useStyles()

  return (
    <>
      <Box className={classes.title}>
        <Text variant='h1'>{pageTitle}</Text>
      </Box>
      <Box className={classes.content}>
        <Typography className={classes.contentText}>
          This page is best experienced on Desktop
        </Typography>
        <Box className={classes.contentSvg}>
          <DesktopOnlyViewSvg />
        </Box>
      </Box>
    </>
  )
}

export default DesktopOnlyView
